enum DefaultLocalMap {
  exhibitor = "Exhibitor",
  show = "Show",
  showId = "",
  stand = "Stand",
  postCode = "Post Code",
  standWallLength = "Wall Length",
  organiser = "Organiser",
}

export default DefaultLocalMap;
